export default __webpack_public_path__ + "static/05-94e21ffcaa3eebca64c35b32863a37f0.png";